import React from 'react';

const fullServiceCards = [
  {
    number: '01',
    title: 'Digital Marketing',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="4" />
        <circle cx="10.5" cy="10.5" r="3.5" />
        <line x1="13" y1="13" x2="16.5" y2="16.5" />
      </svg>
    ),
    renderDesc: () => (
      <>
        Set up a versatile brand’s presence online with our complete{' '}
        <a href="/digital-marketing/" className="full-service-red-link">
          digital marketing solutions
        </a>{' '}
        that bring the best outcomes across all digital mediums. Our strategies create balanced brand experiences that resonate with your target audience. We use modern analytics and market research to produce data driven campaigns that increase brand visibility and generate qualified leads.
      </>
    )
  },
  {
    number: '02',
    title: 'E-Commerce Website Development',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
        <path d="m15 5 4 4" />
        <path d="m3 19 2 2" />
        <path d="m6 16 2 2" />
      </svg>
    ),
    renderDesc: () => (
      <>
        Launch and grow your online business with our{' '}
        <a href="/ecommerce-web-development/" className="full-service-red-link">
          e-commerce development solutions
        </a>
        . We combine modern technology with user-centric design principles that build productive and efficient online stores to provide the best shopping experiences across all devices and platforms. Our e-commerce solutions include secure payment gateway integration and inventory management systems.
      </>
    )
  },
  {
    number: '03',
    title: 'Search Engine Optimization',
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
      </svg>
    ),
    renderDesc: () => (
      <>
        Increase your website’s organic visibility and drive qualified traffic with our{' '}
        <a href="/seo-services/" className="full-service-red-link">
          SEO services
        </a>
        . Our strategies align with technical optimization and on-page content improvement. Our SEO experts perform strategic keyword research and authoritative link-building to improve your search rankings and online authority. We conduct thorough website audits, competitor analysis, and market research to identify opportunities for growth and present long-term results.
      </>
    )
  },
  {
    number: '04',
    title: 'Web Design',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>
    ),
    renderDesc: () => (
      <>
        Our innovative{' '}
        <a href="/web-design/" className="full-service-red-link">
          web design services
        </a>{' '}
        provide functional performance with superior design. Get exceptional user experiences with our professional web designers. Our design idea revolves around your brand identity, target audience, and business objectives. We offer visually attractive websites that tell about your unique selling point. Our designers give importance to responsive design principles so that your website performs well across all devices and screen sizes.
      </>
    )
  },
  {
    number: '05',
    title: 'Web Development',
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
        <polyline points="9 13 12 16 17 11" stroke="#c40a0a" strokeWidth="2.2" />
      </svg>
    ),
    renderDesc: () => (
      <>
        Get strong and efficient web solutions with our{' '}
        <a href="/web-development/" className="full-service-red-link">
          web development services
        </a>
        . Our development team has experience working on modern web technologies and frameworks. We deliver fast-loading, SEO friendly websites that have optimized database structures and secure hosting environments. Our advanced and secure content management systems help us to create websites that are responsive and efficient on every platform.
      </>
    )
  }
];

function FullServiceSmmAgencySection() {
  return (
    <section className="full-service-smm-section">
      <div className="container">
        {/* Section Header */}
        <div className="full-service-smm-header">
          <h2 className="full-service-smm-title">
            Full Service <span style={{ color: '#c40a0a' }}>Social Media Marketing &amp; Digital Marketing</span> Agency
          </h2>
          <p className="full-service-smm-subtitle">
            Experts Communication believes in client satisfaction and quality services. As a leading BPO &amp; IT company, we help many businesses in multiple industries to increase their revenue. We want to create a long-term and fruitful relationship with our clients to sustain their online growth, because we only believe in presenting results and growth.
          </p>
        </div>

        {/* 2-Column Cards Grid */}
        <div className="full-service-smm-grid">
          {fullServiceCards.map((card) => (
            <div key={card.number} className="full-service-smm-card">
              <div className="full-service-card-top">
                <span className="full-service-card-number">{card.number}</span>
                <div className="full-service-card-icon">
                  {card.icon}
                </div>
              </div>

              <h3 className="full-service-card-title">{card.title}</h3>
              <p className="full-service-card-desc">{card.renderDesc()}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FullServiceSmmAgencySection;
